import { Link, Typography } from '@gyym/ui'
import { Instagram, Line, TwitterX } from '@gyym/ui/icons'
import React from 'react'

import { Logo } from '../Logo'
import {
  CircleIconButton,
  Container,
  Copyright,
  InnerContainer,
  NavList,
  NavListItem,
} from './styles'

export interface FooterProps {
  hideTabletFooter?: boolean
}

export const Footer = ({ hideTabletFooter = false }: FooterProps) => {
  return (
    <Container hideTabletFooter={hideTabletFooter}>
      <div className="flex w-full flex-col px-4 tablet:px-8">
        <InnerContainer className="flex-col py-5">
          <div className="flex flex-row items-center justify-between tablet:flex-col">
            <Link href="/">
              <Logo width={60} height={60} />
            </Link>

            <div className="mt-0 flex items-center tablet:mt-4">
              <CircleIconButton
                href="https://twitter.com/gyymofficial"
                target="_blank"
                aria-label="公式X(Twitter)を開く"
              >
                <TwitterX />
              </CircleIconButton>
              <CircleIconButton
                href="https://www.instagram.com/gyym_official"
                target="_blank"
                aria-label="公式Instagramを開く"
              >
                <Instagram />
              </CircleIconButton>
              <CircleIconButton
                href="https://aura-mico.jp/qr-codes/4e40727f39cd843cabeafa59c81b79e7/preview"
                target="_blank"
                aria-label="公式LINEを開く"
              >
                <Line />
              </CircleIconButton>
            </div>
          </div>

          <nav className="ml-0 mt-3 flex flex-col tablet:ml-1 tablet:mt-5">
            <NavList>
              <NavListItem>
                <Link href="/media" target="_blank">
                  GYYM WELLNESS JOURNAL
                </Link>
              </NavListItem>
              <NavListItem>
                <Link href="https://yoyappin.westjr.co.jp/" target="_blank">
                  貸し会議室・レンタルスペース予約Yoyappin
                </Link>
              </NavListItem>
            </NavList>
            <NavList>
              <NavListItem>
                <Link href="/company">会社概要</Link>
              </NavListItem>
              <NavListItem>
                <Link href="/law">特定商取引法に基づく表記</Link>
              </NavListItem>
              <NavListItem>
                <Link href="https://service.gyym.jp/term" target="_blank">
                  利用規約
                </Link>
              </NavListItem>
              <NavListItem>
                <Link href="https://service.gyym.jp/policy" target="_blank">
                  プライバシーポリシー
                </Link>
              </NavListItem>
              <NavListItem>
                <Link href="https://service.gyym.jp/snspolicy" target="_blank">
                  ソーシャルメディアポリシー
                </Link>
              </NavListItem>
              <NavListItem>
                <Link href="https://service.gyym.jp/snsterm" target="_blank">
                  ソーシャルメディアサービス利用規約
                </Link>
              </NavListItem>
              <NavListItem>
                <Link href="https://support.gyym.jp/" target="_blank">
                  よくある質問
                </Link>
              </NavListItem>
              <NavListItem>
                <Link
                  href="https://service.gyym.jp/facility2?utm_source=gyym.jp&utm_campaign=footer_link"
                  target="_blank"
                >
                  提携に関するお問い合わせ
                </Link>
              </NavListItem>
              <NavListItem>
                <Link href="/corp">法人会員サービスに関するお問い合わせ</Link>
              </NavListItem>
            </NavList>
          </nav>
        </InnerContainer>
      </div>

      <Copyright>
        <Typography variant="caption1" color="white">
          Copyright {new Date().getFullYear()} (C) GYYM, Inc.
        </Typography>
      </Copyright>
    </Container>
  )
}
